import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  ControlItemsService,
  ProjectService,
  TenantService,
  UserService,
} from '../../_services/index';

import {MatDatepickerInputEvent} from '@angular/material/datepicker';

import {MatDatepicker} from '@angular/material/datepicker';

import {LoginHelper, Recurring, Role, StringsHelper} from '../../helpers';

import {Router} from '@angular/router';
//import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ClientITProfile, ComplianceArea, ControlItem, ProjectControlItem, User,} from '../../_models/index';

//const now = new Date();
import {TreeNode} from 'primeng/api';
import {WorkstreamService} from "../../_services/workstream.service";
import {ActionItemService} from "../../_services/actionItem.service";
import { ImplementationControlStatementService } from "../../_services/implementationControlStatement.service";
import { FleetsService } from '../../_services/fleets.service';
import { Fleet } from '../../_models/fleet.models';

@Component({
    standalone: false,
  selector: "create-project",
  templateUrl: 'create.project.component.html',
  styleUrls: ['./create.project.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class CreateProjectComponent implements OnInit {
  @ViewChild(MatDatepicker) datepicker: MatDatepicker<Date>;

  //items: any = {};
  //date: moment.Moment;
  model: any = {isPartner: false};
  complianceAreas: TreeNode[];
  controlItems: ControlItem[];
  loading = false;
  clients: User[];
  advisors: User[];
  advisorLeads: User[];
  clientManagers: User[];
  vendors: User[];
  assessors: User[];
  workstreamUsers: User[];
  recurringList: any[];
  currentUser: User;
  rows: any;
  columns: any;
  defaultClients: User[] = [];
  itProfiles: ClientITProfile[];
  workstreams = [];
  actionPlanTemplateSets = [];
  implementationControlStatementSets = [];

  assignedClients: User[];
  assignedClientManagers: User[];
  assignedConsultants: User[];
  assignedConsultantManagers: User[];
  assignedVendors: User[];
  assignedAssessors: User[];
  assignedWorkstreamUsers: User[];
  assignedUsers: User[];
  assignedUsersWithoutPartners: User[];

  selectedItems: any[] = [];

  selectedOwner: any;

  usersLoaded = false;
  complianceAreaLoaded = false;
  canCreatePartnerProjects = false;
  maxLevel: any = 'L5';
  hasLeveledSubItems: boolean = false;
  selectedItProfile?: ClientITProfile[] = [];
  lowPart = {};
  mediumPart = {};
  highPart = {};
  low = {};
  medium = {};
  high = {};
  hasPart = {};
  hasRank = {};
  recommendedControlIds = [];
  hasParents = false;
  fleets: Fleet[] = [];
  isAutonomyEnabled: boolean = false;

  constructor(
    public projectService: ProjectService,
    public complianceAreaService: ComplianceAreaService,
    public userService: UserService,
    public controlItemsService: ControlItemsService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public tenantService: TenantService,
    public workstreamService: WorkstreamService,
    public actionItemService : ActionItemService,
    public implementationControlStatementService : ImplementationControlStatementService,
    public clientProfileService: ClientProfileService,
    public fleetsService: FleetsService,) {

    this.model = { };
    this.assignedClients = [];
    this.assignedClientManagers = [];
    this.assignedConsultants = [];
    this.assignedConsultantManagers = [];
    this.assignedVendors = [];
    this.assignedAssessors = [];
    this.assignedWorkstreamUsers = [];
    this.vendors = [];
    this.workstreamUsers = [];
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    //this.selectedNodes = [];

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let dateIn2Weeks = new Date(Date.now());
    //dateIn2Weeks.setMonth(dateIn2Weeks.getMonth() + 6);

    this.tenantService.getCurrent().subscribe(c => {
      this.canCreatePartnerProjects = c.canCreatePartnerProjects;
      this.isAutonomyEnabled = c.isAutonomyEnabled;
    });

    this.model.dueDate = dateIn2Weeks;
    this.model.isParentContainer = false;
    this.model.displayParentRows = true;

    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {

      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }

    const complianceAreas$ = this.complianceAreaService.getComplianceAreas().subscribe((complianceAreas: ComplianceArea[]) => {
      this.complianceAreas = complianceAreas;

      for (let complianceArea of complianceAreas) {
        for (let category of complianceArea.children) {
          for (let subCategory of category.children) {

            if (subCategory.children != null) {

              for (let controlItem of subCategory.children) {

                const controlItemData = controlItem.data;
                //controlItemData.checked = true;
                //this.selectedItems.push(controlItem);
                this.hasRank[complianceArea.complianceAreaId] = this.hasRank[complianceArea.complianceAreaId] || controlItem.isHigh || controlItem.isMedium || controlItem.isLow;
                controlItemData.dueDate = dateIn2Weeks;
                if (controlItem.frequency) {
                  controlItemData.recurring = this.recurringList.find(r => r.value == controlItem.frequency);
                }
                //this.selectedNodes.push(controlItem);
              }
            }

            if (subCategory.frequency && subCategory.data) {
              subCategory.data.recurring = this.recurringList.find(r => r.value == subCategory.frequency);
            }
            this.hasRank[complianceArea.complianceAreaId] = this.hasRank[complianceArea.complianceAreaId] || subCategory.isHigh || subCategory.isMedium || subCategory.isLow;
            const subCategoryData = subCategory.data;

            //subCategoryData.checked = true;
            //this.selectedItems.push(subCategory);

            subCategoryData.dueDate = dateIn2Weeks;
            //this.selectedNodes.push(subCategory);
          }

          const categoryData = category.data;
          //categoryData.checked = true;
          //this.selectedItems.push(category);

          categoryData.dueDate = dateIn2Weeks;
        }

        const complianceAreaData = complianceArea.data;
        //complianceAreaData.checked = true;
        //this.selectedItems.push(complianceArea);

        complianceAreaData.dueDate = dateIn2Weeks;
      }
      this.complianceAreaLoaded = true;//TODO :: get combineLates
      if (this.usersLoaded) {
        this.updateAssignedUsers();
      }
      this.updateLevel();
    });


    const users$ = this.userService.getAllShort().subscribe(users => {
      users.forEach(x => x.fullName =
        (x.firstName || x.lastName)
          ? x.firstName + ' ' + x.lastName
          : x.emailAddress);

      this.clients = users.filter(user => (user.role & Role.User) != 0);
      this.clients.forEach(
        x => x.fullName =
          (x.firstName || x.lastName)
            ? x.firstName + ' ' + x.lastName
            : x.emailAddress
      );

      this.currentUser = users.find(user => user.userId == this.currentUser.userId);

      this.advisors = users.filter(user => (user.role & Role.AdvisorStaff) != 0);
      this.vendors = users.filter(user => (user.role & Role.Vendor) != 0);
      this.assessors = users.filter(user => (user.role & Role.Assessor) != 0);
      this.workstreamUsers = users.filter(user => (user.role & Role.Engineer) != 0);

      this.advisorLeads = users.filter(user => (user.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0);
      this.clientManagers = users.filter(user => (user.role & (Role.Manager | Role.PrimaryManager)) != 0);

      this.assignedConsultantManagers = [];
      this.usersLoaded = true;
      if (this.complianceAreaLoaded) {
        this.updateAssignedUsers();
      }
    });

    this.clientProfileService.getClientProfiles(tenantName).subscribe(c => {
      this.itProfiles = c;
    });

    this.model.workstreamId = null;
    this.workstreamService.getWorkstreams().subscribe(w => {
      this.workstreams = w;
    });
    this.actionItemService.getAllActionItemTemplateSets().subscribe(s => this.actionPlanTemplateSets = s);
    this.implementationControlStatementService.getAllImplementationControlStatementSets().subscribe(s => this.implementationControlStatementSets = s);

    this.fleetsService.getAll().subscribe({
      next: fleets => {
        this.fleets = fleets;
      }
    });
  }

  getFullName(user: User) {
    const a = this.clientManagers;
    return StringsHelper.getFullName(user);
  }

  onProjectDateChanged(type: string, event: MatDatepickerInputEvent<Date>) {

    const changedDate = event.value;

    for (let complianceArea of this.complianceAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of category.children) {

          if (subCategory.children != null) {

            for (let controlItem of subCategory.children) {

              controlItem.data.dueDate = changedDate;
            }
          }

          subCategory.data.dueDate = changedDate;
        }

        category.data.dueDate = changedDate;
      }

      complianceArea.data.dueDate = changedDate;
    }
  }

  /*
  nodeSelect(event) {
  }

  nodeUnselect(event) {
  }

  nodeClick(event) {
  }

  selectionChange(event) {
  }
  */

  onClientsChange() {
    let overwrite = false;
    const availableAdvisorLeads = this.assignedConsultantManagers;
    const availableClientManagers = this.assignedClientManagers;
    this.defaultClients = this.defaultClients.filter(u => availableClientManagers.indexOf(u) >= 0 || availableAdvisorLeads.indexOf(u) >= 0);
    const defaultManagers = this.defaultClients.filter(u => availableClientManagers.indexOf(u) >= 0);
    if (this.assignedClientManagers.length > 0) {
      if (this.defaultClients.length == 0 || defaultManagers.length == 0) {
        overwrite = true;
      }
      this.defaultClients = [this.assignedClientManagers[0]];
    } else if (availableAdvisorLeads.length > 0) {
      if (this.defaultClients.length == 0) {
        overwrite = true;
      }
      this.defaultClients = [availableAdvisorLeads[0]];
    }

    for (let complianceArea of this.complianceAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of category.children) {

          if (subCategory.children != null) {

            for (let controlItem of subCategory.children) {
              controlItem.data.assignedClientList = complianceArea.data.assignedClientList && this.assignedUsers.filter(a => complianceArea.data.assignedClientList.indexOf(a) >= 0).length >= 0 && !overwrite
                ? controlItem.data.assignedClientList.filter(u => this.assignedUsers.indexOf(u) >= 0) : this.defaultClients;
            }
          }

          subCategory.data.assignedClientList = complianceArea.data.assignedClientList && this.assignedUsers.filter(a => complianceArea.data.assignedClientList.indexOf(a) >= 0).length >= 0 && !overwrite
            ? subCategory.data.assignedClientList.filter(u => this.assignedUsers.indexOf(u) >= 0) : this.defaultClients;
        }

        category.data.assignedClientList = complianceArea.data.assignedClientList && this.assignedUsers.filter(a => complianceArea.data.assignedClientList.indexOf(a) >= 0).length >= 0 && !overwrite
          ? category.data.assignedClientList.filter(u => this.assignedUsers.indexOf(u) >= 0) : this.defaultClients;
      }

      complianceArea.data.assignedClientList = complianceArea.data.assignedClientList && this.assignedUsers.filter(a => complianceArea.data.assignedClientList.indexOf(a) >= 0).length >= 0 && !overwrite
        ? complianceArea.data.assignedClientList.filter(u => this.assignedUsers.indexOf(u) >= 0) : this.defaultClients;
    }


  }

  arraySame(a: any[], b: any[]) {
    return a && b && a.filter(i => b.indexOf(i) >= 0).length == a.length && b.filter(i => a.indexOf(i) >= 0).length == b.length;
  }

  onNodeRecurringChanged(event, value, node) {

    //console.log(node.parent);

    if (node.parent != null) {
      node.parent.data.recurring = null;
    }

    const dateNow = value.value != Recurring.None
      ? new Date(Date.now())
      : null;

    this.nodeRecurringChanged(event, value, node, dateNow);
  }

  nodeRecurringChanged(event, value, node, startDate) {

    node.data.recurring = value;
    node.data.startDate = startDate;

    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.nodeRecurringChanged(event, value, child, startDate);
    }
  }

  onNodeClientChanged(event, value, node) {
    node.data.assignedClientList = value;
    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.onNodeClientChanged(event, value, child);
    }
  }

  onNodeStartDateChanged(type: string, event: MatDatepickerInputEvent<Date>, node) {
    node.data.startDate = event.value;
    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.onNodeStartDateChanged(type, event, child);
    }
  }

  onNodeDateChanged(type: string, event: MatDatepickerInputEvent<Date>, node) {
    node.data.dueDate = event.value;
    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.onNodeDateChanged(type, event, child);
    }
  }

  onCreate() {
    let data;
    let subItem;
    let item;
    let errorMessage;
    if (this.model.name == null ||
      (this.assignedClients.length == 0 &&
        this.assignedClientManagers.length == 0 &&
        this.assignedConsultantManagers.length == 0 &&
        this.assignedConsultants.length == 0) ||
      this.model.dueDate == null) {

      errorMessage = 'You should fill all required fields.';
      this.alertService.error(errorMessage);
      return;
    }

    this.loading = true;
    this.alertService.loading.next(true);

    //var selectedControlItems = [];
    const selectedControlItems: ProjectControlItem[] = [];

    //this.selectedNodes.filter(x => x.data.id != null).forEach(x => selectedControlItems.push(x.data));
    for (let complianceArea of <any[]>this.complianceAreas) {
      for (let category of <any[]>complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {
            for (let controlItem of <any[]>subCategory.children) {
              if (this.selectedItems.indexOf(controlItem) >= 0 && controlItem.data.controlItemId != 0) {

                data = controlItem.data;
                data.recurring = data.recurring == null ? 0 : data.recurring.value;

                for (let i = 0; i < data.assignedClientList.length; i++) {
                  item = Object.assign({}, data);
                  item.assignedClient = data.assignedClientList[i];
                  selectedControlItems.push(item);
                  const dueDate = item.dueDate;
                  if (controlItem.subItems && controlItem.subItems.length) {
                    for (let j = 0; j < controlItem.subItems.length; j++) {
                      subItem = controlItem.subItems[j];
                      if (subItem.level <= this.maxLevel || !complianceArea.hasLevels) {
                        item = Object.assign({}, subItem);
                        item.dueDate = dueDate;
                        item.assignedClient = data.assignedClientList[i];
                        selectedControlItems.push(item);
                      }
                    }
                  }
                }
              }
            }
          }

          if (this.selectedItems.indexOf(subCategory) >= 0 && subCategory.data.controlItemId != 0) {
            data = subCategory.data;
            data.recurring = data.recurring == null ? 0 : data.recurring.value;

            for (let i = 0; i < data.assignedClientList.length; i++) {
              item = Object.assign({}, data);
              item.assignedClient = data.assignedClientList[i];
              item.reviewRequired = data.reviewRequired;
              selectedControlItems.push(item);
              const dueDate = item.dueDate;
              if (subCategory.subItems && subCategory.subItems.length) {
                for (let j = 0; j < subCategory.subItems.length; j++) {
                  subItem = subCategory.subItems[j];
                  if (subItem.level <= this.maxLevel || !complianceArea.hasLevels) {
                    item = Object.assign({}, subItem);
                    item.dueDate = dueDate;
                    item.assignedClient = data.assignedClientList[i];
                    selectedControlItems.push(item);
                  }
                }
              }
            }
          }
        }
      }
    }

    if (selectedControlItems.length == 0) {

      errorMessage = 'You should choose at least one Control Item.';
      this.alertService.error(errorMessage);
      return;
    }

    this.model.projectControlItems = selectedControlItems;
    this.model.clientITProfileIds = this.selectedItProfile.map(p => p.clientITProfileId).join(';')

    let users = [];
    users = users.concat(this.assignedConsultants.map(x => {
      const user = new User(x.userId);
      user.role = Role.AdvisorStaff;
      return user;
    }));

    users = users.concat(this.assignedClients.map(x => {
      const user = new User(x.userId);
      user.role = Role.User;
      return user;
    }));

    users = users.concat(this.assignedConsultantManagers.map(x => {
      const user = new User(x.userId);
      user.role = Role.AdvisorLead;
      return user;
    }));

    users = users.concat(this.assignedClientManagers.map(x => {
      const user = new User(x.userId);
      user.role = Role.Manager;
      return user;
    }));

    if (this.model.isPartner) {
      users = users.concat(this.assignedVendors.map(x => {
        const user = new User(x.userId);
        user.role = Role.Vendor;
        return user;
      }));
    }

    users = users.concat(this.assignedAssessors.map(x => {
      const user = new User(x.userId);
      user.role = Role.Assessor;
      return user;
    }));

    users = users.concat(this.assignedWorkstreamUsers.map(x => {
      const user = new User(x.userId);
      user.role = Role.Engineer;
      return user;
    }));

    this.model.assignedUsers = users;

    this.model.tenantName = LoginHelper.getTenantName();

    if (this.selectedItProfile) {
      this.model.clientITProfileIds = this.selectedItProfile.map(p => p.clientITProfileId).join(';');
    }

    this.projectService.create(this.model)
      .subscribe(
        data => {
          this.alertService.loading.next(false);
          if (data.error) {
            this.alertService.error(data.error);
          } else {
            this.alertService.success('The project was successfully created.', true);
            this.router.navigate(['/projects']);
          }
        },
        error => {
          this.alertService.loading.next(false);
          this.loading = false;
          if (error._body) {
            this.alertService.error(error._body);
          } else {
            this.alertService.error(error.error);
          }
        });

    this.loading = false;
  }

  updateAssignedUsers() {
    this.assignedUsers = this.assignedClients.concat(this.assignedClientManagers).concat(this.assignedConsultants).concat(this.assignedConsultantManagers).concat(this.assignedAssessors).concat(this.assignedWorkstreamUsers);
    this.assignedUsersWithoutPartners = [...this.assignedUsers];
    if (this.model.isPartner) this.assignedUsers = this.assignedUsers.concat(this.assignedVendors)

    this.onClientsChange();
  }

  selectAllPartners(event, node) {
    node.data.assignedClientList = node.data.assignedClientList.concat(this.vendors);
    this.onNodeClientChanged(event, node.data.assignedClientList, node)
    this.updateAssignedUsers();
  }

  notTenant(users) {
    return users;
  }

  updateLevel() {
    let anyWithLabel = false;
    let hasParents = false;

    for (let complianceArea of this.complianceAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {

            for (let controlItem of <any[]>subCategory.children) {
              if (this.selectedItems.indexOf(controlItem) >= 0) {
                if ((<any>complianceArea).hasLevels) {
                  anyWithLabel = true;
                }
                if (controlItem.data.subItems && controlItem.data.subItems.length) {
                  anyWithLabel = anyWithLabel || (<any>complianceArea).hasLevels || controlItem.data.subItems.find(s => s.complianceArea.hasLevels);
                  hasParents = true;
                }
              }
            }
          }
          if (this.selectedItems.indexOf(subCategory) >= 0 && subCategory.data.controlItemId != 0) {
            const data = subCategory;

            if (this.selectedItems.indexOf(subCategory) >= 0) {
              if ((<any>complianceArea).hasLevels) {
                anyWithLabel = true;
              }
              if (subCategory.subItems && subCategory.subItems.length) {
                anyWithLabel = anyWithLabel || (<any>complianceArea).hasLevels || subCategory.subItems.find(s => s.complianceArea.hasLevels);
                hasParents = true;
              }
            }
          }
        }
      }
    }

    this.hasParents = hasParents;
    this.hasLeveledSubItems = anyWithLabel;
    if (this.hasLeveledSubItems && !this.maxLevel) {
      this.maxLevel = 'L5';
    }
    this.setDisables();
  }

  setDisables() {
    for (let complianceArea of this.complianceAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {

            for (let controlItem of <any[]>subCategory.children) {
              if (controlItem.data.subItems && controlItem.data.subItems.length) {
                if (this.selectedItems.indexOf(controlItem) >= 0) {
                  controlItem.disabled = !controlItem.subItems.find(s => s.level <= this.maxLevel || !(<any>complianceArea).hasLevels);
                  if (controlItem.disabled && this.selectedItems.indexOf(controlItem)) {
                    this.selectedItems = this.selectedItems.filter(i => i != controlItem);
                  }
                }
              }
            }
          }
          if (this.selectedItems.indexOf(subCategory) >= 0 && subCategory.data.controlItemId != 0) {
            const data = subCategory;

            if (subCategory.subItems && subCategory.subItems.length) {
              subCategory.disabled = !subCategory.subItems.find(s => s.level <= this.maxLevel || !(<any>complianceArea).hasLevels);
              if (subCategory.disabled && this.selectedItems.indexOf(subCategory) >= 0) {
                this.selectedItems = this.selectedItems.filter(i => i != subCategory);
              }
            }
          }
        }
      }
    }
  }

  a(a, b) {
    debugger;
  }

  lowChanged(complianceArea, $event) {
    this.low[complianceArea.complianceAreaId] = $event.checked;
    this.setSelection(complianceArea);
  }

  mediumChanged(complianceArea, $event) {
    this.medium[complianceArea.complianceAreaId] = $event.checked;
    this.setSelection(complianceArea);
  }

  highChanged(complianceArea, $event) {
    this.high[complianceArea.complianceAreaId] = $event.checked;
    this.setSelection(complianceArea);
  }

  setSelection(complianceArea) {
    for (let category of complianceArea.children) {
      for (let subCategory of <any[]>category.children) {

        if (subCategory.children != null) {

          for (let controlItem of <any[]>subCategory.children) {
            if (controlItem.isLow || controlItem.isMedium || controlItem.isHigh) {
              if (controlItem.isLow && this.low[complianceArea.complianceAreaId] || controlItem.isMedium && this.medium[complianceArea.complianceAreaId] || controlItem.isHigh && this.high[complianceArea.complianceAreaId]) {
                this.selectedItems.push(controlItem);
              } else {
                this.selectedItems = this.selectedItems.filter(i => i != controlItem);
              }
            }
          }
        }
        if (subCategory.isLow || subCategory.isMedium || subCategory.isHigh)
          if (subCategory.isLow && this.low[complianceArea.complianceAreaId] || subCategory.isMedium && this.medium[complianceArea.complianceAreaId] || subCategory.isHigh && this.high[complianceArea.complianceAreaId]) {
            this.selectedItems.push(subCategory);
          } else {
            this.selectedItems = this.selectedItems.filter(i => i != subCategory);
          }
      }
    }
    this.selectedItems = [...this.selectedItems];
    this.initSelection([complianceArea]);
  }

  initSelection(nodes): { all: boolean, some: boolean } {
    const result = {all: true, some: false};
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].children && nodes[i].children.length) {
        //nodes[i].data.disabled = true;
        const childStatus = this.initSelection(nodes[i].children);
        if (childStatus.all) {
          this.selectedItems.push(nodes[i]);
        } else {
          result.all = false;
        }
        if (childStatus.some && !childStatus.all) {
          nodes[i].partialSelected = true;
        }
        if (!childStatus.some) {
          nodes[i].partialSelected = false;
        }
        result.some = result.some || childStatus.some;
      }
      if (this.selectedItems.indexOf(nodes[i]) >= 0 || nodes[i].partialSelected) {
        result.some = true;
      } else {
        result.all = false;
      }

    }
    return result;
  }

  updateRecommendedControls() {
    this.recommendedControlIds = this.selectedItProfile.flatMap(p => p.recommendedControlIds);
  }

  updateLeveledSelection(repeat) {
    const selectedAreas = [];
    for (let complianceArea of this.complianceAreas) {
      let hasChildren = false;
      let anySelected = false;
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {

            for (let controlItem of <any[]>subCategory.children) {
              if (this.selectedItems.indexOf(controlItem) >= 0) {
                anySelected = true;
                if (controlItem.data.subItems && controlItem.data.subItems.length) {
                  hasChildren = true;
                }
              }
            }
          }
          if (this.selectedItems.indexOf(subCategory) >= 0 && subCategory.data.controlItemId != 0) {

            if (this.selectedItems.indexOf(subCategory) >= 0) {
              anySelected = true;
              if (subCategory.subItems && subCategory.subItems.length) {
                hasChildren = true;
              }
            }
          }
        }
      }
      if (!hasChildren && anySelected) {
        selectedAreas.push(complianceArea);
      }
    }

    for (let complianceArea of selectedAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {
          if (subCategory.children != null) {
            for (let controlItem of <any[]>subCategory.children) {
              if (controlItem.level <= this.maxLevel) {
                if (this.selectedItems.indexOf(controlItem) < 0) {
                  this.selectedItems = this.selectedItems.concat([controlItem]);
                }
              } else {
                this.selectedItems = this.selectedItems.filter(i => i != controlItem);
              }
            }
          }
          if (subCategory.data.controlItemId != 0) {
            if (subCategory.level <= this.maxLevel) {
              if (this.selectedItems.indexOf(subCategory) < 0) {
                this.selectedItems = [...this.selectedItems.concat([subCategory])];
                console.log(this.selectedItems);
              }
            } else {
              this.selectedItems = this.selectedItems.filter(i => i != subCategory);
            }
          }
        }
      }
      complianceArea.children = [...complianceArea.children];
    }

    if (repeat !== false) {
      setTimeout(() => this.updateLeveledSelection(false), 0);
    }
    this.updateAssignedUsers();
  }
}
